import Hero from "../components/Hero";
import Navbar from "../components/Navbar";

function Notebook(){
    return(
        <>
            <Navbar/>
            <Hero
                cName="hero-content" 
                heroImg="https://static.igem.wiki/teams/4696/wiki/molecules.png"
                title="Notebook"
            />
        </>
    )
}

export default Notebook;